require('./bootstrap');
require('./translations');
require('./filters');
require('./window');

import store from './store'

const files = require.context('./vue/app/components', true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(key.split('/').pop().split('.')[0], files(key).default)
);

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

import VueQr from 'vue-qr'
Vue.use(VueQr)

import WidgetInit from './vue/app/components/WidgetInit'
import Event from './vue/app/components/Event'
import Timetable from './vue/app/components/Timetable'
import Checkout from './vue/app/components/Checkout'

const routes = [
    // { path: '/', redirect: '/dashboard' },
    { path: '/', name: 'widgetinit', component: WidgetInit },
    { path: '/:eventid', name: 'event', component: Event },
    { path: '/:eventid/:timetableid', name: 'timetable', component: Timetable },
    { path: '/order/:id/:hash', name: 'checkout', component: Checkout },
//     { path: '/eloquent_configs', name: 'eloquent_configs', component: Configs },
//     { path: '/general_config', name: 'general_config', component: GeneralConfig },
//     { path: '/translation', name: 'translation', component: Translation },
//     { path: '/subscriptions', name: 'subscriptions', component: Subscriptions },
//     { path: '/order/:orderid', name: 'order', component: Order },
//     { path: '/timetable/:id', name: 'timetable', component: Timetable },
//     { path: '/venue/:id', name: 'venue', component: DrawVenue },
//     { path: '/section/:id', name: 'section', component: DrawSection },
//     { path: '/:model', name: 'eloquent_list', component: EloquentList },
]

const router = new VueRouter({
    // mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

// router.beforeEach((to, from, next) => {
//     next()
// })

const load = () => {
    new Vue({
        el: '#vue-event',
        router,
        store,
    });
}

let $el = document.getElementById("vue-event")

if($el) {
    store.dispatch('getSettings').then(() => {
        load()
    })
}

